import React from 'react';
import styled from 'styled-components';
import { string, func, bool, object, any } from 'prop-types';
import './radio.css';
import Text from '../Text';
import { connect } from 'formik';

const RadioLabel = styled.label`
  margin: 0px 12px 0 0;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
`;

const Radio = ({ label, onChange, name, disabled, checked, value, setFieldValue, isOrderProductDetail }) => {
    const formatResponse = (value) => value === 'on';

    return isOrderProductDetail
        ? <label className='radio-container'>
            { label && <Text text={label} /> }
            <input type='radio' className='radio-toolbar' onChange={({ target }) => onChange(formatResponse(target.value))} />
            <span className='radio-checkmark' />
        </label>
        : <label className='radio-container'>
            { label && <RadioLabel onClick={onChange}>{ label }</RadioLabel> }
            <input
                value={value}
                type='radio'
                disabled={disabled}
                className='radio-toolbar'
                name={name}
                checked={checked}
                onChange={({ target }) => {
                    setFieldValue(name, target.value);
                }}
            />
            <span className='radio-checkmark' disabled={disabled} />
        </label>;
};

const FormikRadio = connect(({ field, form: { errors, dirty, touched, ...form }, formik: { setFieldValue }, ...rest }) => {
    return (<Radio {...field} {...rest} setFieldValue={setFieldValue} />);
});

FormikRadio.propTypes = {
    form: object,
    field: object,
    formik: object
};

Radio.propTypes = {
    checked: bool,
    disabled: bool,
    name: string,
    label: string,
    onChange: func,
    value: string,
    setFieldValue: any,
    isOrderProductDetail: bool
};

export { Radio, FormikRadio };
